export const words = {
  place: "Helyszín",
  yes: "Igen",
  no: "Nem",
  new: "Új",
  agb: 'AGB',
  agb_full: "Általános szerződési feltételek",
  datenschutzerklaerung: "Adatvédelmi szabályzat",
  status: "Állapot",
  company_name: "Cégnév",
  next_button: "További",
  device_name: "Eszköz neve",
  to_connect: "Csatlakozás",
  pin: "PIN-KÓD",
  time: "Idő",
  first_name: "Keresztnév",
  last_name: "Vezetéknév",
  code: "Kód:",
  help: "Segítség",
  total_time: "Teljes idő",
  latitude: "Szélesség",
  longitude: "Hosszúság",
  accuracy: "Pontosság",
  timestamp: "Időbélyegző",
  device_id: "Eszköz azonosítója",
  active: "aktív",
  o_clock: "Óra",
  loading: "Shop",
  annotation: "Megjegyzés:",
  since: "mivel",
  camera: 'Kamera',
  map: "Térkép",
  gallery: "Galéria",
  work: "Munka",
  employees: "Alkalmazottak",
  login: "Regisztráció",
  login_action: "Bejelentkezés",
  calendar_week_abbreviation: 'KW',
  calendar: "Naptár",
  to_call: "Hívja a  címet.",
  email: "E-mail",
  attachment: "Függelék",
  operational_planning: "Operatív terv",
  to_scan: "Szkennelés",
  download: "Letöltés",
  export: "Exportálás",
  to_document: "Dokumentum",
  checklist: "Ellenőrző lista",
  checklists: "Ellenőrző listák",
  password: "Jelszó",
  confirmation: "Megerősítés",
  confirm: "Megerősítés",
  confirmation_email: "Megerősítő e-mail",
  unknown: "Ismeretlen",
  unknown_place: "Ismeretlen helyszín",
  unknown_plan: "Névtelen műszaki menetrend",
  project_no: "A projekt száma.",
  project_file: "Projekt fájl",
  contact_person: "Kapcsolat",
  overtime: "Túlóra",
  timesheet: "Menetrend",
  minustime: "Mínusz órák",
  back: "Vissza",
  undo: "Undo",
  clockout: "Stamp out",
  clocked_out: "pecsétes",
  clockin: "Stamp in",
  clocked_in: "pecsétes",
  dismiss: "Törölje",
  discard: "Elutasít",
  finish: "Kész",
  or: "vagy",
  copy: "Másolat",
  qr_code: "QR-kód",
  documentation: "Időnyilvántartás és dokumentáció",
  attendance: "Tablet terminál",
  tiercontent: "A csomag hatóköre",
  start_now: "Kezdje el most",
  skip: "ugorj át",
  logout_during_core_time: "Kipréselve az alapidő alatt",
  absent_during_core_time: "Hiányzik a magidő alatt",
  distance: "Távolság",
  km_reading: "Kilométerek száma",
  the_start: "Indítsa el a  oldalt.",
  the_end: "Vége",
  license_plate: "Rendszámtábla",
  details: "részletek",
  hide: "elrejtése",
  cost: "Költségek",
  file: "Fájl",
  address_book: "Címjegyzék",
  template_plural: "Sablonok",
  signature: "Aláírás",
  main_project: "Fő projekt",
  main_projects: "Főbb projektek",
  sub_projects: "Alprojektek",
  scan_to_login_header: "QR-kód regisztráció",
  description: "Leírás",
  project_location: "A projekt helye",
  phone_number: "Telefonszám",
  project_info: "A projektre vonatkozó információk",
  number_short: "Nem.",
  sketch: "Sketch",
  video: 'Video',
  delete: "Törölje a  címet.",
  send: "Küldje el a",
  sending: "Küld...",
  save: "Mentés",
  granted: "jóváhagyott",
  pending: "kért",
  denied: "Visszautasított",
  customer: "Ügyfél",
  mobile_number: "Telefonszám",
  ok: "Oké",
  day: "Nap",
  tomorrow: "Reggel",
  days: "Napok | Nap | Napok",
  holidays: "Ünnepek",
  vacation_days: "Ünnepek",
  vacation_hours: "Szabadság nyitvatartási ideje",
  request: "Kérés",
  accept: "Elfogadom",
  withdraw: "Bevon",
  hour_account: "Órabéres számla",
  period: "Időszak",
  to: "a  címre.",
  date: "Időpontkérés",
  number: "Szám",
  message: "Üzenet",
  change: "változás",
  changed: "Változtatott",
  changed_fields: "Mezőváltás",
  type: 'Art',
  hour: "Óra",
  hours: "Órák",
  hours_abbreviation: 'Std.',
  hours_with_amount: "{amount} Órák",
  end: "vége",
  end_date: "Határidő",
  start_date: "Kezdeti időpont",
  absence: "Távollét",
  month: "hónap",
  week: "Hét",
  transcript: "Átirat",
  time_left: "megmaradó",
  transcript_tasks: "Feladatok",
  add_task: "Új",
  /** Differentiation in some languages (e.g. English) */
  from: "a  címről",
  of: "a  címről",
  of_hours: "{hours} órától",
  of_hours_abbreviation: "{hours} órák óta.",
  /**************/

  used: "használt",
  update: "Frissítés",
  today: "ma",
  correction: "Helyesbítés",
  work_time: "Munkaidő",
  break: "Szünet",
  loading_time: "Betöltési idő",
  driving_time: "Utazási idő",
  business_trip: "Szolgálati körút",
  project: 'Projekt',
  special_one: "Special1",
  special_two: "Special2",
  clock: "Óra",
  search: "Keresés",
  operation: "Tevékenység",
  day_protocol: "Napi protokoll",
  continue: "további",
  total_duration: "Teljes idő",
  duration: "Időtartam",
  hello: "Hello",
  close: "close",
  comment: "Comment",
  small: "kis",
  medium: "közepes",
  large: "nagy",
  sharpie: "Pin",
  line: "Vonal",
  arrow: "Arrow",
  rectangle: "Téglalap alakú",
  ellipse: "Ellipszis",
  text: "Szöveg",
  language_settings: "Nyelvi beállítások",
  clock_reminder: "Bélyegemlékeztető",
  individually: "Egyéni",
  from_o_clock: "a  címről",
  to_o_clock: "a  címre.",
  eraser: "Radír",
  edit: "Szerkesztés",
  legal_notes: "Jogi",
  notes: "Megjegyzések",
  note: "Megjegyzés:",
  imprint: "Impresszum",
  open_source_licenses: "Nyílt forráskódú licencfeltételek",
  author: "Szerző",
  license_type: "Az engedély típusa",
  version: "Verzió",
  substitute: "Képviselet",
  not_rated: "Nincs értékelve",
  weekly_working_hours: "Heti munkaidő",
  show_less: "Kevesebb mutatása",
  office_center: "Irodaközpont",
  admin_view: "NFC menedzsment",
  register: "Regisztráció",
  shifts: {
    shift_attachments: "Csatolások (réteg)",
    shift_plan_attachments: "Csatolások (műszaktervezés)",
    shift_plan: "Műszak menetrendje",
    shift: "Réteg"
  },
  absences: {
    sick: "Betegség (bérpótlék)",
    vacation: "Nyaralás",
    workshop: "Szeminárium/tanfolyam",
    special_vacation: "Különleges szabadság",
    school: "Iskola",
    working_time_account: "Munkaidő-számla",
    holiday: "Nyaralás",
    other: "Egyéb",
    driving_time: "Utazási idő",
    parental_leave: "Szülői szabadság",
    excused_absent: "Mentesített távollét (fizetett)",
    not_excused_absent: "Menthetetlen hiányzás",
    sick_industrial_accident: "Betegség Üzemi baleset (LFZ)",
    short_time_work: "Rövid munkaidő (Kug)",
    maternity_pay: "Kismamavédelmi bér/foglalkoztatási tilalom",
    sick_child: "Beteg gyermek ápolása beteg (napidíjjal)",
    sick_child_no_payment: "Beteg gyermek ápolása táppénz (napidíj) nélkül",
    vacation_no_payment: "Fizetetlen szabadság",
    sick_before_short_time_work: "Betegségi ellátás/betegség a Kug előtt",
    weather_related_failure: "Időjárási körülmények miatti meghibásodás",
    sick_short_time_work: "Betegség a Kug alatt",
    sick_no_payment: "Betegség (a bérfizetés folytatása nélkül)",
    company_vacation: "Céges ünnepek",
    meals_14_euro: "Kis étkezési hozzájárulás",
    meals_28_euro: "Nagy étkezési hozzájárulás"
  },
  image_editor: {
    font_size: "Betűméret",
    stroke_width: "Vonalszélesség",
    stroke_color: "Vonal színe",
    text_color: "Betűszín",
    rotate_left: "Forduljon balra",
    rotate_right: "Forduljon jobbra",
    flip_horizontal: "Tükör vízszintesen",
    flip_vertical: "Tükör függőlegesen"
  },
  travel_log: {
    method_of_transportation: "Közlekedési eszközök",
    company_car: "Céges autó",
    private_car: "Személygépkocsi",
    rental_car: "Bérelt autó",
    taxi: 'Taxi',
    public_transportation: "Tömegközlekedés",
    airplane: "Repülőgép",
    train: "Vasút (távolsági tömegközlekedés)",
    other: "Egyéb",
    km_reading_start: "Kilométerek kezdete",
    km_reading_end: "Kilométeróra vége",
    net_expenses: "Utazási költségek (nettó)",
    tax: "Hozzáadottérték-adó"
  },
  read_in: "Olvassa be",
  currency: "Pénznem",
  reason: "Indoklás",
  label: "Címke",
  monday: "Hétfő",
  tuesday: "Kedd",
  wednesday: "Szerda",
  thursday: "Csütörtök",
  friday: "Péntek",
  saturday: "Szombat",
  sunday: "Vasárnap",
  break_alarm: "Törd meg az ébresztőórát",
  clockin_reminder: "Bejelentkezési emlékeztető",
  clockout_reminder: "Feliratkozás visszalépési emlékeztető"
};